import { render, staticRenderFns } from "./alarm-check.vue?vue&type=template&id=01261af0&scoped=true&"
import script from "./alarm-check.vue?vue&type=script&lang=js&"
export * from "./alarm-check.vue?vue&type=script&lang=js&"
import style0 from "./alarm-check.vue?vue&type=style&index=0&id=01261af0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01261af0",
  null
  
)

export default component.exports